<div data-scroll-container>
  <div class="content relative h-screen">
    <div class="progress-bar" [style.height.%]="scrollProgress"></div>
    <div class="home block lg:flex items-center" id="about_page">
      <section class="service_sec about_sec" id="about" data-scroll-section>
        <a routerLink="/" routerLinkActive="router-link-active" class="to_back">
          <i class="fa-solid fa-arrow-left"></i>
          Back To Home
        </a>
        <div class="row about_disc">
          <div class="content_div about_content" data-scroll data-scroll-speed="1">
            <span class="for_mob">About Me</span>
            <div class="sec_head">
              <h2>Hardik Godhani</h2>
            </div>
            <p>
              I'm a full-stack developer based in India with over 4 years of experience building
              scalable web applications and modern digital solutions. I’ve worked with startups,
              agencies, and enterprise teams across various industries — helping turn business needs
              into clean, high-performing software. My work is driven by a strong understanding of
              both frontend and backend development, allowing me to take full ownership of projects
              from concept to deployment.
            </p>
            <p>
              I enjoy collaborating with teams that value thoughtful design and robust engineering.
              My focus is on creating intuitive user experiences backed by well-structured, secure,
              and efficient backend systems. I prioritize timely delivery and maintain a high
              standard of code quality, ensuring every solution is reliable, maintainable, and
              aligned with long-term business goals.
            </p>
            <p>
              Over the years, I’ve developed 20+ full-stack applications using Angular, Vue.js, and
              Node.js, while also contributing to 100+ code reviews to ensure technical excellence.
              I stay current with the latest frameworks, tools, and industry trends — continuously
              refining my skills to deliver solutions that are not only functional but future-ready.
            </p>
          </div>
        </div>
        <div class="abt_image" data-scroll data-scroll-speed=".8">
          <div class="hardik_photo">
            <figure
              class="lazyloaded"
              style="background-image: url('assets/about/profile-img.jpeg')"
            ></figure>
          </div>
          <div class="hardik_sign">
            <figure
              class="lazyloaded"
              style="background-image: url('assets/about-page/hardik_sign.gif')"
            ></figure>
          </div>
        </div>
      </section>
      <app-awards-section></app-awards-section>
      <app-affiliation-section></app-affiliation-section>
      <!-- <app-join-us></app-join-us> -->
    </div>
  </div>
</div>
